import { AssetPreviewTabResultsPostsController } from './asset-preview-tab-results-posts.controller'

function assetPreviewTabResultsPosts () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      contextData: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-results-posts/asset-preview-tab-results-posts.html?$$REVISION$$',
    controller: AssetPreviewTabResultsPostsController
  }
}
export { assetPreviewTabResultsPosts }
